{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} Konversationen ausgewählt",
    "NONE": "Keine",
    "CLEAR_SELECTION": "Leeren",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {agentName}? | Are you sure you want to assign {n} conversations to {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
    "YES": "Ja",
    "CANCEL": "Stornieren",
    "SEARCH_INPUT_PLACEHOLDER": "Suchen",
    "ASSIGN_AGENT_TOOLTIP": "Agent zuweisen",
    "ASSIGN_TEAM_TOOLTIP": "Team zuweisen",
    "ASSIGN_SUCCESFUL": "Konversationen erfolgreich zugewiesen.",
    "ASSIGN_FAILED": "Konversationen konnten nicht zugewiesen werden. Bitte versuchen Sie es erneut.",
    "RESOLVE_SUCCESFUL": "Konversationen erfolgreich gelöst.",
    "RESOLVE_FAILED": "Konversationen konnten nicht gelöst werden. Bitte versuchen Sie es erneut.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Nur auf dieser Seite sichtbaren Konversationen sind ausgewählt.",
    "UPDATE": {
      "CHANGE_STATUS": "Status ändern",
      "SNOOZE_UNTIL": "Erinnern",
      "UPDATE_SUCCESFUL": "Der Konversationsstatus wurde erfolgreich aktualisiert.",
      "UPDATE_FAILED": "Konversationen konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Konversationen können aufgrund fehlender notwendiger Attribute nicht gelöst werden",
      "PARTIAL_SUCCESS": "Einige Konversationen benötigen zum Lösen erforderliche Attribute und wurden übersprungen"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Labels zuweisen",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Ausgewählte Labels zuweisen",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "Labels erfolgreich zugewiesen.",
      "ASSIGN_FAILED": "Labels konnten nicht zugewiesen werden. Bitte versuchen Sie es erneut.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "Keine",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {teamName}? | Are you sure you want to assign {n} conversations to {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
      "ASSIGN_SUCCESFUL": "Teams erfolgreich zugewiesen.",
      "ASSIGN_FAILED": "Team konnte nicht zugewiesen werden. Bitte versuche es erneut."
    }
  }
}
